import React from 'react';
import './BombGameTutorial.css';

const BombGameTutorial = ({ onClose }) => {
  return (
    <div className="tutorial-overlay">
      <div className="tutorial-content bomb-tutorial">
        <div className="tutorial-header">
          <h2>数独危機一髪の遊び方</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="tutorial-body">
          <section className="tutorial-section">
            <h3>ゲームの目的</h3>
            <p>
              数独マスターの危機一髪モードは、黒ひげ危機一髪のように「正しいマス」を見つけるゲームです。
              数独の盤面から「安全に消せるマス」を1つ選んでください。
              消せるマスとは、そのマスを消しても数独の解が一意（1つだけ）に決まるマスです。
            </p>
          </section>
          
          <section className="tutorial-section">
            <h3>基本ルール</h3>
            <ol>
              <li>盤面の中から、消去しても一意解が保たれるマスを1つ選びます。</li>
              <li>正解の場合、「おめでとう」画面が表示されます。</li>
              <li>不正解の場合、なぜそのマスを選ぶと一意解が失われるのかの説明と、正解のヒントが表示されます。</li>
            </ol>
          </section>
          
          <section className="tutorial-section">
            <h3>数独の一意解とは？</h3>
            <p>
              数独の「一意解」とは、その盤面を解くときに答えがただ1つしかない状態を指します。
              すべてのマスの数字を一意に決定できる必要があります。
              一部のマスを消すと、複数の妥当な解が存在するようになることがあります。
              そのようなマスは「消してはいけないマス」となります。
            </p>
          </section>
          
          <section className="tutorial-section">
            <h3>ヒントとコツ</h3>
            <ul>
              <li>
                <strong>周囲の制約を確認する：</strong>
                同じ行、列、3×3ブロック内の数字が、そのマスの値を一意に決定できるか考えます。
              </li>
              <li>
                <strong>「消せるマス」は複数存在：</strong>
                通常、複数の正解があります。どれか1つ見つければクリアです。
              </li>
              <li>
                <strong>解の一意性の考え方：</strong>
                そのマスを消したとき、他の数字から一意に値が決まるかどうかが重要です。
              </li>
            </ul>
          </section>
          
          <section className="tutorial-section">
            <h3>結果画面について</h3>
            <p>
              結果画面では、正解の場合は他の「消せるマス」も表示されます。
              不正解の場合は、なぜそのマスを消すと一意解が失われるのかの詳細な説明と
              正解のマスのリストが表示されます。これを参考に数独の理解を深めましょう。
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default BombGameTutorial;